//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { InvoiceMode, InvoiceFormat } from './Enums';

export class AutoInvoiceUpdateItem extends ItemBase {
    NextInvoiceBillPeriod: string | null = null;
    InvoiceRepeatDetails: RepeatDetailsItem | null = null;
    GenerateZeroAmountInvoices: boolean = false;
    IncludeBalanceForwardOnInvoices: boolean = false;
    InvoicingMode: InvoiceMode | null = null;
    AutoEmailInvoices: boolean = false;
    AutoInvoiceFooter: string | null = null;
    InvoiceDateOffset: number = 0;
    DueDateOffset: number | null = null;
    InvoiceFormat: InvoiceFormat | null = null;

    constructor(initializer?: Partial<AutoInvoiceUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AutoInvoiceUpdateItem";
}
